module.exports = __webpack_public_path__ + "static/media/25.7f761bef.JPG";